import React, { Component } from 'react'

class ErrorMessage extends Component {
  render () {
    const { error } = this.props
    if (!error || Object.keys(error).length === 0) { return <div className='error-container' /> } else {
      return (
        <div className='error-container'>
          <div className='error-message' dangerouslySetInnerHTML={{ __html: this.props.error && this.props.error.message.toString() }} />
          <div className='error-message-small'>{this.props.error && this.props.error.friendlyCode}</div>
        </div>

      )
    }
  }
}

export default ErrorMessage



// WEBPACK FOOTER //
// ./src/widgets/common/ErrorMessage.js